import React, {useState} from 'react';
import {Divider, Row, Typography, Space, Image, Carousel, Button} from "antd";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import 'swiper/css';
import "swiper/css/pagination";
import "swiper/css/navigation";

const { Title, Text } = Typography;

const ResultStagePanel = ({resultStage, onImageClick, selectedResult}) => {
    const hasBorder = (item) => {
        if (selectedResult.hasOwnProperty("url")) {
            return selectedResult.url === item.url
        }
        return false;
    }

    const [visibility, setVisibility] = useState({});
    const [scaleStep, setScaleStep] = useState(0.5);

    return (
        <div
            style={{
                margin: 16
            }}
        >
            <Title
                level={5}
                style={{marginTop: 16, marginBottom: 16, marginLeft: 16, float: "left"}}
            >
                Results - Generation #{resultStage.items[0].level}
            </Title>
            <Divider />
            <Swiper
                direction='horizontal'
                slidesOffsetAfter={192}
                slidesPerView={3}
                spaceBetween={16}
                navigation={{
                    nextEl: ".next-el",
                    prevEl: ".prev-el"
                }}
                style={{margin: 24}}
                pagination={{clickable: true}}
                keyboard={true}
                modules={[Pagination, Navigation, Keyboard]}
            >
                {
                    resultStage.items.map( item =>
                        <SwiperSlide key={item.url} style={{margin: 32}}>
                            <Button
                                type="link"
                                onClick={() => {
                                    const newVisibility = {...visibility};
                                    newVisibility[item.url] = true;
                                    setVisibility(newVisibility);
                                }}
                                style={{marginLeft: 32}}
                            >
                                Open preview
                            </Button>
                            <Image
                                style={{
                                    width: 0,
                                    height: 0
                                }}
                                preview={{
                                    visible: visibility[item.url],
                                    scaleStep,
                                    src: item.url,
                                    onVisibleChange: (value, prevValue) => {
                                        const newVisibility = {...visibility};
                                        newVisibility[item.url] = value;
                                        setVisibility(newVisibility);
                                    }
                                }}
                            />
                            <Image
                                src={item.url}
                                preview={false}
                                placeholder={true}
                                style={{
                                    marginBottom: 48,
                                    marginTop: 16,
                                    marginLeft: 16,
                                    outline: hasBorder(item) ? "4px solid #1890FF" : "none",
                                    outlineOffset: "4px"
                                }}
                                onClick={() => onImageClick(item)}
                            />
                        </SwiperSlide>
                    )
                }
            </Swiper>
        </div>
    );
};

export default ResultStagePanel;